<template>
  <div class="menucontrol-scroll fixed-top">
    <Banner />
    <CourseCategoryTable />
  </div>
</template>
<script>
import Banner from "./components/Banner.vue";
import CourseCategoryTable from "./components/CourseCategoryTable.vue";
export default {
  components: {
    Banner,
    CourseCategoryTable,
  },
};
</script>
